var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-title-box"},[_c('span',{staticClass:"din model-span"},[_vm._v(" "+_vm._s(_vm.model)+" ")]),_c('span',{staticClass:"c-span"},[_vm._v(" "+_vm._s(_vm.ch)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }